import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { auth, db } from "../firebaseConfig"; 
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { LayoutDashboard, LogOut } from "lucide-react";
import "../App.css";
import logo from "../assets/logo.png";

const Navbar = () => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Listen for Auth changes internally
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsLoggedIn(true);
        // Fetch role from Firestore
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setIsLoggedIn(false);
        setUserRole(null);
      }
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/signin");
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <motion.nav
      className="navbar"
      initial={{ y: 0 }}
      animate={{ y: showNavbar ? 0 : -100 }}
      transition={{ duration: 0.3 }}
    >
      <div className="navbar-show">
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <div className={`navbar-toggle ${isMobileMenuOpen ? "active" : ""}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          <span></span><span></span><span></span>
        </div>

        <ul className={`navbar-links ${isMobileMenuOpen ? "active" : ""}`}>
          <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link></li>
          <li><Link to="/About" onClick={() => setIsMobileMenuOpen(false)}>About Us</Link></li>
          <li><Link to="/exchange-rate" onClick={() => setIsMobileMenuOpen(false)}>Exchange Rates</Link></li>
          <li><Link to="/regulations" onClick={() => setIsMobileMenuOpen(false)}>Regulations</Link></li>
          <li><Link to="/agents" onClick={() => setIsMobileMenuOpen(false)}>Clearing Agents</Link></li>
          <li><Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link></li>

          {!isLoggedIn ? (
            <>
              <li className="navbar-auth"><Link to="/signin" className="auth-btn" onClick={() => setIsMobileMenuOpen(false)}>Sign In</Link></li>
              <li className="navbar-auth"><Link to="/signup" className="auth-btn" onClick={() => setIsMobileMenuOpen(false)}>Sign Up</Link></li>
            </>
          ) : (
            <>
              {userRole === "admin" && (
                <li className="navbar-auth">
                  <Link to="/admin" className="dashboard-link-btn" onClick={() => setIsMobileMenuOpen(false)}>
                    <LayoutDashboard size={18} /> Dashboard
                  </Link>
                </li>
              )}
              <li className="navbar-auth">
                <button onClick={() => { handleLogout(); setIsMobileMenuOpen(false); }} className="logout-btn">
                  <LogOut size={18} /> Logout
                </button>
              </li>
            </>
          )}
        </ul>
      </div>
    </motion.nav>
  );
};

export default Navbar;